import React, { FC } from 'react';

import {
  GetServerSideProps,
  GetServerSidePropsContext,
  GetServerSidePropsResult
} from 'next';
import { ParsedUrlQuery } from 'querystring';
import Head from 'next/head';
import { robotsTagContent } from 'src/utils/seo';
import { fetchCache } from 'src/api/caching/cacheUtils';
import { triggerCustomStatusCodeRedirect } from 'src/ssr/errorStatusCodeRedirect';
import HelpPageContainer from '../page-components/help/HelpPageContainer';
import {
  GeneralServerProps,
  generalSSRProps,
  getCacheConfig,
  isQueryParamsValid,
  setSSRCacheControl
} from '../ssr/generalSsrUtil';
import { Category } from '../api/types';

interface Props extends GeneralServerProps {
  categoriesList: Category[];
}
const HelpPage: FC<Props> = () => {
  return (
    <>
      <Head>
        <meta name="robots" content={robotsTagContent} key="robots" />
      </Head>
      <HelpPageContainer />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext<ParsedUrlQuery>
) => {
  setSSRCacheControl(context);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return fetchCache<GetServerSidePropsResult<{ [key: string]: any }>>(
    getCacheConfig(context),
    async () => {
      const generalProps = await generalSSRProps(context);
      if (!isQueryParamsValid(context.query)) {
        // Redirect to 410 because the URL contains invalid query params
        return triggerCustomStatusCodeRedirect(context.res, 410);
      }

      return {
        props: {
          ...generalProps
        }
      };
    }
  );
};

export default HelpPage;
